// Central app configuration - change brand here only
export const APP_CONFIG = {
  APP_NAME: 'Lexigen AI',
  APP_TAGLINE: 'Your AI legal team for starting and managing a business in India.',
  APP_DOMAIN: process.env.NEXT_PUBLIC_APP_DOMAIN || 'lexigen.ai',
  APP_LOGO: '/assets/images/app_logo.png',
  APP_SHORT_NAME: 'Lexigen',
  APP_DESCRIPTION: 'AI-powered legal and business registration platform for India. Start, protect and manage your business with AI-powered legal and compliance intelligence.',
  SUPPORT_EMAIL: 'support@lexigen.ai',
  DEMO_EMAIL: 'demo@lexigen.ai',
  DEMO_PASSWORD: 'demo1234',
  APP_FULL_NAME: 'LEXIGEN AI',
  APP_POSITIONING: 'AI-POWERED LEGAL & BUSINESS REGISTRATION',
  APP_TAGLINE_SHORT: 'AI PREPARES. HUMANS APPROVE.',
};

export default APP_CONFIG;
